{
	"title": "Χαρακτηριστικά που συλλαμβάνονται από άνθρακα",
	"buttonTitle": "Σύλληψη και αποθήκευση άνθρακα",
	"table": {
		"materialDescription": "Υλικό",
		"quantity": "Ποσότητα",
		"productGwpTotal": "Προϊόν GWP Σύνολο",
		"bundledCarbonReductions": "Ομαδοποιημένες μειώσεις άνθρακα",
		"remainingGwp": "Υπόλοιπο GWP",
		"epdForPhysicalMaterial": "EPD για φυσικό υλικό",
		"carbonPlantName": "Brevik, Νορβηγία"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "είναι ο νόμιμος κάτοχος των αναφερόμενων μειώσεων άνθρακα."
	},
	"modal": {
		"title": "Σύλληψη και αποθήκευση άνθρακα",
		"description": "Η δέσμευση και αποθήκευση άνθρακα (CCS) είναι μια τεχνολογία που μπορεί να συλλάβει τις εκπομπές διοξειδίου του άνθρακα (CO2) που παράγονται από τη διαδικασία πύρωσης και τη χρήση καυσίμων στη λειτουργία του κλιβάνου, εμποδίζοντας το διοξείδιο του άνθρακα να εισέλθει στην ατμόσφαιρα και να το αποθηκεύσει μόνιμα υπόγεια. Το CO2 που δεσμεύεται από το εργοστάσιο της Heidelberg Materials στο Brevik της Νορβηγίας, συμπιέζεται και μεταφέρεται σε χώρο αποθήκευσης κάτω από τη Βόρεια Θάλασσα. Οι εγκαταστάσεις στο εργοστάσιό μας στο Brevik θα απορροφούν 400.000 τόνους CO2 ετησίως.",
		"showLink": "Μάθετε περισσότερα σχετικά με τη διαδικασία δέσμευσης άνθρακα",
		"buttonClose": "Κλείσιμο"
	},
	"footnote": "1) Οι μειώσεις άνθρακα αντισταθμίζουν τα στάδια Α1-Α3 του αποθέματος του κύκλου ζωής του τσιμέντου."
}
